import Address from "@/types/Address.interface"

export default {
    state: {},
    mutations: {},
    actions: {
        addressesPost ({commit, getters}, address: Address): Address {
            return window.axios.post(`${getters.api}/addresses`, address).then(response => {
                return response.data
            }).catch(() => {
                return null
            })
        },
        addressesPut({commit, getters}, address: Address): Address {
            return window.axios.put(`${getters.api}/addresses`, address).then(response => {
                return response.data
            }).catch(() => {
                return null
            })
        }
    },
    getters: {}
}